import styled from "styled-components";
import { device } from "../../../../globalStyles/breakpoints";

export const RetailMatchKeyMetricsWrapper = styled("div")`
  display: grid;
  grid-template-columns: 80px 1fr;
  grid-column-gap: 20px;
  grid-template-rows: 80px;
  grid-row-gap: 20px;
  margin: 50px 0px 150px 0px;
  align-items: center;
  &:last-child {
    margin-bottom: 104px;
  }

  ${device.desktop} {
    grid-template-columns: 129px 1fr;
    grid-template-rows: 70px;
    grid-column-gap: 40px;
    grid-row-gap: 20px;
  }
`;

export const RetailMatchKeyMetricsDescription = styled("div")`
  text-align: center;
  font-family: Manrope, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #333;
  height: 100%;
`;
